/*
==================================================
Featured Launches
Version: 1.0
Vanilla JS
==================================================
*/

class FeaturedLaunchCard {
  constructor(card) {
    this.card = card;

    this.tags = [...card.querySelectorAll(".fl-tag")];
    this.slides = [...card.querySelectorAll(".fl-image-slide")];

    if (!this.tags.length || !this.slides.length) return;

    this.current = 0;
    this.timer = null;

    this.autoplay =
      card.dataset.autoplay === "true" ||
      card.dataset.autoplay === "1";

    this.speed = Number(card.dataset.speed || 4) * 1000;

    this.init();
  }

  init() {
    this.preloadImages();

    this.bindEvents();

    this.show(0, false);

    if (this.autoplay) {
      this.start();
    }
  }

  /*------------------------------------
  Preload Images
  ------------------------------------*/

  preloadImages() {
    this.tags.forEach((tag) => {
      const src = tag.dataset.image;

      if (!src) return;

      const img = new Image();
      img.src = src;
    });
  }

  /*------------------------------------
  Events
  ------------------------------------*/

  bindEvents() {
    this.tags.forEach((tag, index) => {
      tag.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.show(index);

        this.restart();
      });
    });

    this.card.addEventListener("mouseenter", () => {
      this.stop();
    });

    this.card.addEventListener("mouseleave", () => {
      this.start();
    });

    this.card.addEventListener("focusin", () => {
      this.stop();
    });

    this.card.addEventListener("focusout", () => {
      this.start();
    });

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        this.stop();
      } else {
        this.start();
      }
    });

    this.enableTouch();
  }

  /*------------------------------------
  Touch Support
  ------------------------------------*/

  enableTouch() {
    let startX = 0;

    this.card.addEventListener(
      "touchstart",
      (e) => {
        startX = e.changedTouches[0].clientX;
      },
      { passive: true }
    );

    this.card.addEventListener(
      "touchend",
      (e) => {
        let endX = e.changedTouches[0].clientX;

        let diff = endX - startX;

        if (Math.abs(diff) < 40) return;

        if (diff < 0) {
          this.next();
        } else {
          this.prev();
        }

        this.restart();
      },
      { passive: true }
    );
  }

  /*------------------------------------
  Show Slide
  ------------------------------------*/

  show(index, animate = true) {
    if (index < 0) index = this.slides.length - 1;

    if (index >= this.slides.length) index = 0;

    this.current = index;

    this.tags.forEach((tag, i) => {
      tag.classList.toggle("is-active", i === index);

      tag.setAttribute(
        "aria-selected",
        i === index ? "true" : "false"
      );
    });

    this.slides.forEach((slide, i) => {
      slide.classList.toggle("is-active", i === index);

      if (!animate) {
        slide.style.animation = "none";

        requestAnimationFrame(() => {
          slide.style.animation = "";
        });
      }
    });
  }

  /*------------------------------------
  Next
  ------------------------------------*/

  next() {
    this.show(this.current + 1);
  }

  /*------------------------------------
  Prev
  ------------------------------------*/

  prev() {
    this.show(this.current - 1);
  }

  /*------------------------------------
  Timer
  ------------------------------------*/

  start() {
    if (!this.autoplay) return;

    this.stop();

    this.timer = setInterval(() => {
      this.next();
    }, this.speed);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
    }

    this.timer = null;
  }

  restart() {
    this.stop();

    this.start();
  }

  destroy() {
    this.stop();
  }
}

/*
==================================================
Initialize
==================================================
*/

const FeaturedLaunches = {
  instances: [],

  init(scope = document) {
    scope
      .querySelectorAll(".fl-card")
      .forEach((card) => {
        if (card.dataset.loaded) return;

        card.dataset.loaded = true;

        this.instances.push(
          new FeaturedLaunchCard(card)
        );
      });
  },

  destroy() {
    this.instances.forEach((instance) => {
      instance.destroy();
    });

    this.instances = [];
  }
};

/*
==================================================
Ready
==================================================
*/

document.addEventListener("DOMContentLoaded", () => {
  FeaturedLaunches.init();
});

/*
==================================================
Shopify Theme Editor
==================================================
*/

document.addEventListener(
  "shopify:section:load",
  (event) => {
    FeaturedLaunches.init(event.target);
  }
);

document.addEventListener(
  "shopify:section:unload",
  () => {
    FeaturedLaunches.destroy();
  }
);

/*
==================================================
Optional Keyboard Support
==================================================
*/

document.addEventListener("keydown", (event) => {
  const active = document.activeElement;

  if (!active.classList.contains("fl-tag")) return;

  const card = active.closest(".fl-card");

  if (!card) return;

  const tags = [...card.querySelectorAll(".fl-tag")];

  const index = tags.indexOf(active);

  if (event.key === "ArrowRight") {
    event.preventDefault();

    const next =
      tags[(index + 1) % tags.length];

    next.focus();
    next.click();
  }

  if (event.key === "ArrowLeft") {
    event.preventDefault();

    const prev =
      tags[(index - 1 + tags.length) % tags.length];

    prev.focus();
    prev.click();
  }
});